<mat-dialog-content>
  <div class="cosmos-element-details-modal__close-button-wrapper">
    <button
      (click)="closeDetails()"
      class="cosmos-element-details-modal__close-button-wrapper__button"
    >
      <mat-icon>
        <span>close</span>
      </mat-icon>
    </button>
  </div>
  <cosmos-element-summary
    [element]="_element"
    class="cosmos-element-details-modal__element-summary"
  ></cosmos-element-summary>
  <cosmos-section
    [loading]="loading"
    sectionTitle="Tags"
    class="cosmos-element-details-modal__section"
  >
    <cosmos-element-tag></cosmos-element-tag>
  </cosmos-section>
  <cosmos-section
    *ngIf="_element"
    [loading]="loading"
    sectionTitle="Preview"
    class="cosmos-element-details-modal__section"
  >
    <div class="cosmos-element-details-modal__preview">
      <cosmos-element-preview
        [element]="_element"
        [isCompact]="false"
      ></cosmos-element-preview>
    </div>
  </cosmos-section>
  <button
    (click)="deleteElement()"
    class="cosmos-element-details-modal__delete-button"
  >
    Delete element
  </button>
</mat-dialog-content>
